import { render, staticRenderFns } from "./ImportFilesView.vue?vue&type=template&id=5fc36957&scoped=true&"
import script from "./ImportFilesView.vue?vue&type=script&lang=js&"
export * from "./ImportFilesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc36957",
  null
  
)

export default component.exports